// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.textField_vhRHs {
  padding: var( --size-padLarge );
}

.button_JiCN9 {
  margin: var( --size-padLarge );
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-elements/lib/esm/ErrorBoundary.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":[".textField {\n  padding: var( --size-padLarge );\n}\n\n.button {\n  margin: var( --size-padLarge );\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textField": `textField_vhRHs`,
	"button": `button_JiCN9`
};
export default ___CSS_LOADER_EXPORT___;
